import firebase from "./firebase";
import { firestore as db } from "./firebase";
import { BaseModel } from "./models";
import { AuthenticatedUser } from "./users";
import { Statement, getStatuses, StatementListItem } from "./statements";

export const COLLECTION_STATEMENTS: string = "statements";
export const COLLECTION_STATEMENT_FOLLOWERS: string = "statement_followers";

// The StatementFollower type defines how a user following a statement is stored in the Firestore database.
export type StatementFollower = BaseModel & {
  user: {
    userId: string;
    displayname: string;
  };
  statement: {
    statementId: string;
    title: string;
    status: string;
    slug: string;
  };
};

export function getStatementFollower(
  statementId: string,
  userId: string,
  setStatementFollowing: (following: boolean) => void
) {
  return db
    .collection(COLLECTION_STATEMENT_FOLLOWERS)
    .where("user.userId", "==", userId)
    .where("statement.statementId", "==", statementId)
    .limit(1)
    .onSnapshot((snapshot) => {
      let data: StatementFollower[] = [];
      snapshot.forEach((doc) => data.push({ ...doc.data() } as any));
      setStatementFollowing(data.length > 0);
    });
}

export async function followStatement(
  statement: Statement,
  user: AuthenticatedUser
) {
  // Add a new StatementFollower document.
  const document = db.collection(COLLECTION_STATEMENT_FOLLOWERS).doc();
  const statementFollower: StatementFollower = {
    id: document.id,
    timestamp: firebase.firestore.Timestamp.now(),
    statement: {
      statementId: statement.id,
      title: statement.title,
      status: statement.status,
      slug: statement.slug,
    },
    user: {
      userId: user.id,
      displayname: user.displayname,
    },
  };
  await document.set(statementFollower);
}

export async function unfollowStatement(statementId: string, userId: string) {
  // Delete the StatementFollower document for the user/statement combination.
  const data = await db
    .collection(COLLECTION_STATEMENT_FOLLOWERS)
    .where("user.userId", "==", userId)
    .where("statement.statementId", "==", statementId)
    .limit(1)
    .get();

  data.forEach((doc) => doc.ref.delete());
}

export async function getStatementsUserIsFollowing(
  userId: string,
  isAdmin: boolean
) {
  const data = await db
    .collection(COLLECTION_STATEMENT_FOLLOWERS)
    .where("user.userId", "==", userId)
    .where("statement.status", "in", getStatuses(isAdmin))
    .get();

  let statements: StatementFollower[] = [];
  data.forEach((doc) => statements.push({ ...doc.data() } as any));
  return statements;
}

export function mapToListItem(statement: StatementFollower): StatementListItem {
  return {
    id: statement.statement.statementId,
    slug: statement.statement.slug,
    title: statement.statement.title,
  };
}
